import script from "./OLLSetEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./OLLSetEditor.vue?vue&type=script&setup=true&lang=js"

import "./OLLSetEditor.vue?vue&type=style&index=0&id=acbee8ac&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acbee8ac"]])

export default __exports__